import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import TablePage from './TablePage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ABIEntrySummaryTranslationProvider from '../contexts/ABIEntrySummaryTranslationContext'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <TablePage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedTablePage as TablePage
}
